/* eslint-disable no-shadow */
import React, { Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import get from "lodash/get";
import { bindActionCreators } from "redux";
import { browserHistory } from "react-router";

import config from "../../utils/config.js";
import * as actions from "../../actions";

import "./SSOLogin.scss";

export class SSOLogin extends Component {
  static propTypes = {
    actions: PropTypes.object.isRequired,
    location: PropTypes.object.isRequired,
    user: PropTypes.object.isRequired,
  };

  componentDidMount() {
    const { actions, location, user } = this.props;
    const token = get(location, "query.code", "");
    const ssoPage = window.location.pathname === "/sso";
    if (token && !get(user, "isLoggedIn", false) && ssoPage) {
      actions
        .loginSso(token, config.csc)
        .then((res) => {
          if (res.status === 1) {
            browserHistory.replace("/customer-info");
          } else {
            this.handleError();
          }
        })
        .catch((err) => {
          console.log("Error: ", err);
          this.handleError();
        });
    } else if (!ssoPage) {
      browserHistory.replace("/login");
    }
  }

  handleError = () => {
    if (confirm("Error while login, Do you want to try again?")) {
      browserHistory.replace("/login?isFromCSC");
    } else {
      browserHistory.replace("/login");
    }
  };

  render() {
    return (
      <div className="container">
        <img src={require("../../images/loader.svg")} alt="loading" />
      </div>
    );
  }
}

export default connect(
  (state) => ({
    user: state.user,
  }),
  (dispatch) => ({
    actions: bindActionCreators(actions, dispatch),
  })
)(SSOLogin);
